export const SET_IS_LOADED = "CATEGORY_DETAIL:SET_IS_LOADED";
export const SET_IS_FETCHING = "CATEGORY_DETAIL:SET_IS_FETCHING";
export const SET_LIST = "CATEGORY_DETAIL:SET_LIST";
export const SET_LIST_INFO = "CATEGORY_DETAIL:SET_LIST_INFO";
export const UPDATE_LIST = "CATEGORY_DETAIL:UPDATE_LIST";
export const CLEAR_DATA = "CATEGORY_DETAIL:CLEAR_DATA";
export const ADD_FILTERS_PARAMS = "CATEGORY_DETAIL:ADD_FILTERS_PARAMS";
export const ADD_FAVORITE = "CATEGORY_DETAIL:ADD_FAVORITE";
